import { Star } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { S } from "./summaryCopy";
import { T } from "./i18n";

// Compact reviews block: rating, count and the regional-median comparison.
// Deliberately no list of individual reviews: those are the paid report's.
export default function ReviewsSummary({ data, lang }) {
  if (data?.review_count == null) return null;
  const C = (S[lang] || S.de).reviewsSummary;
  const L = T[lang] || T.de;
  return (
    <section data-testid="reviews-summary" className="mt-6 rounded-2xl border bg-card p-5 shadow-sm sm:p-6">
      <h2 className="mb-3 font-heading text-lg font-semibold sm:text-xl">{C.title}</h2>
      <div className="mb-3 flex flex-wrap items-center gap-x-6 gap-y-2">
        {data.rating != null && (
          <div className="flex items-center gap-1.5">
            <Star className="h-5 w-5 fill-amber-400 text-amber-400" />
            <span className="text-2xl font-semibold tabular-nums">{lang === "en" ? `${data.rating}` : `${data.rating}`.replace(".", ",")}</span>
            <span className="text-sm text-muted-foreground">{C.ratingLabel}</span>
          </div>
        )}
        <div className="flex items-baseline gap-1.5">
          <span className="text-2xl font-semibold tabular-nums">{`${data.review_count}`}</span>
          {/* The teaser sentence below names the count in words; the label stays for screen readers only. */}
          <span className="sr-only">{C.countLabel}</span>
        </div>
      </div>
      <Accordion type="single" collapsible defaultValue="reviews-text" className="print:hidden">
        <AccordionItem value="reviews-text" className="rounded-xl border px-4">
          <AccordionTrigger className="text-left text-base font-medium">{C.reviewsMore}</AccordionTrigger>
          <AccordionContent>
      <p className="text-base text-muted-foreground">
        {L.reviewsTeaser(data.review_count, data.benchmark?.review_median, data.review_analysis?.index)}
      </p>
      {L.reviewsDeliverables?.length > 0 && (
        <div className="mt-3">
          <p className="text-sm font-medium text-muted-foreground">{L.reviewsDeliverablesLead}</p>
          <ul className="mt-1.5 list-disc space-y-1 pl-5 text-base text-muted-foreground">
            {L.reviewsDeliverables.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </div>
      )}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </section>
  );
}
